import { render } from "./TheAlertDialog.vue?vue&type=template&id=20983930"
import script from "./TheAlertDialog.vue?vue&type=script&lang=js"
export * from "./TheAlertDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__